module.exports = __webpack_public_path__ + "img/info-and-advice.e551600f.png";